var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmergencytrackingicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1227_8030)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1227_8030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6153 19.2666C16.8672 20.0314 18.5021 19.6365 19.2668 18.3846C20.0316 17.1327 19.6367 15.4979 18.3848 14.7331C17.1329 13.9684 15.4981 14.3632 14.7333 15.6151C13.9685 16.867 14.3634 18.5019 15.6153 19.2666Z",
    stroke: "#EBBC21",
    strokeWidth: 2.65625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4182 8.59955C25.3427 7.24614 27.4416 6.64852 29.7604 6.43427C29.7407 6.42207 29.7233 6.40763 29.7036 6.39555C22.2038 1.81403 12.5146 3.96123 7.93311 11.461C5.07007 16.1477 6.31102 22.139 10.5821 25.4003C8.65759 26.7538 6.55867 27.3514 4.23982 27.5656C4.25953 27.5778 4.27693 27.5923 4.29671 27.6043C11.7965 32.1859 21.4856 30.0387 26.0672 22.5389C28.9303 17.8521 27.6892 11.8608 23.4182 8.59955Z",
    stroke: "#EBBC21",
    strokeWidth: 2.65625,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1227_8030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1227_8030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(11.3551 -6.36963) rotate(31.4202)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencytrackingicon);
export default __webpack_public_path__ + "static/media/emergencytrackingicon.b648915e9d6cc0c66aeb2facce1d5953.svg";
export { ForwardRef as ReactComponent };